import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SelectionEvent } from '@progress/kendo-angular-grid';
import { SelectEvent, TabPosition, TabStripComponent } from '@progress/kendo-angular-layout';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { PersonSummary } from '~/models/administration/person';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { SiteLisitng } from '~/models/administration/site';
import { UserSummary } from '~/models/administration/user';
import { EntityStatusOptions } from '~/models/entityStatus';
import { IAssetModelDto, IModelInfo } from '~/models/modules/Asset/assetModel';
import { assetModelFile } from '~/models/modules/Asset/assetModelFiles';
import { AssetTypeDto } from '~/models/modules/Asset/assetType';
import { IModelClassDto } from '~/models/modules/Asset/modelClass';
import { CategoryListing, CategorySummary } from '~/models/modules/category';
import { CustomFieldSummary } from '~/models/modules/customField';
import { FormTabSummary } from '~/models/modules/formTab';
import { GridFieldSummary } from '~/models/modules/gridField';
import { GridFieldTextSummary } from '~/models/modules/GridFieldText';
import { IUPCBarcodes } from '~/models/modules/upcBarcodes';
import { AccountsService } from '~/services/administration.ts/accounts';
import { UPCOnlineSettingsService } from '~/services/administration.ts/upc-online-settings';
import { UsersService } from '~/services/administration.ts/users';
import { EnvironmentLoaderService } from '~/services/BackEndURL/environment-loader.service';
import { GDataService } from '~/services/GDataService';
import { AssetModel2Service } from '~/services/modules/assets/asset-model-2.service';
import { AssetModelService } from '~/services/modules/assets/asset-model.service';
import { AssetTypeService } from '~/services/modules/assets/assetType';
import { ModelClassService } from '~/services/modules/assets/modelClass.service';
import { SitesEnum } from '~/shared/enums/sites.enum';
import { MultiSiteAwareComponent } from '~/infrastructure/multi-site-aware.component';
import { MultiSiteService } from '~/services/modules/common/multi-site.service';
import { CategoriesService } from '~/services/modules/stocks/categories';
import { CustomFieldsService } from '~/services/modules/stocks/custom-fields';
import { FilesService } from '~/services/modules/stocks/files';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { SecurityService } from '~/services/security.service';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { NoteComponent } from '~/shared/components/note/note.component';
import { fileSources } from '~/shared/enums/fileSources';
import { PageState } from '~/shared/enums/stock-files.enum';

@Component({
    selector: 'assetmodel-upsert-2',
    templateUrl: './upsert.component.html',
    styleUrls: ['./upsert.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AssetModelUpsert2Component extends MultiSiteAwareComponent {

  // #region Basic Variables
  _entity = 'asset';
  _page = 'asset-models-2';
  _permissionScope = 'asset-models-2';
  _theme: string;
  _currentUser: UserSummary;
  _active: boolean;
  _pageState: PageState;
  // _isLiveEnterprise: boolean;
  _model: IAssetModelDto;
  _language = 'en';
  _form: FormGroup;
  _gridFieldText: GridFieldTextSummary[];
  _invalidForm: boolean = false;
  _invalidSubmit: boolean;
  _isOs: boolean;

  _gridFieldAuth: GridFieldAuthorization[];
  _customForm: any;
  _isDialiog: boolean = false;
  _dialogComponentName: string;
  _dialogModel: any;
  _storagePath: string; //for the files library
  selectedobjectname: string = null;
  copyModelId: number;
  behavior: BehaviorSubject<GridFieldSummary[]>;
  // #endregion

  // #region Tab Containers
  _kendoTabStripPosition: TabPosition = 'left';
  _dataTabs: Array<FormTabSummary> = [];
  _dataTabsSelected: Array<FormTabSummary> = [];
  _userNewDataTabs: Array<FormTabSummary> = [];
  _customTabs: any;
  // #endregion

  // #region Window Properties
  _innerWidth: number;
  _hiddenWindow: string;
  _maximized: string;

  // #endregion

  // #region Popup Statuses
  _editFormActive: boolean;
  _orderingTabsForm: boolean = false;
  _deactivatedFieldsForm: boolean = false;
  _isEditForms: boolean = false;
  _selectedTabId: number;
  _selectedLabelId: number;
  _deactivatedFieldsGridData: any[] = [];
  // #endregion

  // #region Custom Fields / Edit Form
  _isCustomfieldsFormValue: boolean = false;
  _isAddTabFormValue: boolean = false;
  _isRenameLabel: boolean = false;
  _selectedLabelObjectCode: string;
  _isRenameFormValue: boolean = false;
  _isRenameCustomFormValue: boolean = false;
  _isMandatory: boolean = false;
  _custominvalidForm: boolean = false;
  reactivate: boolean = false;
  reactivateItem: any;
  requiredSystemTabs: any = [];
  _requiredFieldNames: any = [];
  _requiredFields: any = [];
  _additionalErrors: any = [];

  _customFields: CustomFieldSummary[][] = [];
  _customFieldsDictionary: { [key: string]: string } = {};
  _customFieldsValue: any[];
  _customValidation: any = [];
  _systemFields: any = [];
  _editedSystemFields: any = [];
  // #endregion

  // #region HTML Elements References
  @ViewChild('mainWindow') kendoMainWindow: ElementRef;
  @ViewChild('kendo_tabstrip_wrapper') screenTabs: ElementRef;
  @ViewChild('kendo_tabstrip') public screenTabStrip: TabStripComponent;
  @ViewChild('kendo_ModelNumber') kendoInputModelNumber: ElementRef;
  @ViewChild('kendo_ModelName') kendoInputModelName: ElementRef;
  @ViewChild('note') note: NoteComponent;
  // #endregion

  // #region Current Page Specific
  _modelNumber = new FormControl();
  _modelName = new FormControl();
  _categoryDD = new FormControl();
  _modelTypeDD = new FormControl();
  _sitesDD = new FormControl();
  // UPC search
  isUpcOnlineSetting: boolean = false;
  isUPCResultEnabled: boolean = false;
  _upcResult: IUPCBarcodes[] = [];
  _selectedUPC: IUPCBarcodes;

  //Sites Drop
  _siteAuth: GridFieldAuthorization;
  _selectSitesGridActive: boolean;
  _sitesPageName: string = 'sites';
  _sitesGridFields: GridFieldSummary[];
  _selectedsite: number;
  //Categories Drop
  categoriesData: CategoryListing[] = [];
  _categoryAuth: GridFieldAuthorization;
  _selectCategoriesGridActive: boolean;
  _categoriesPageName: string = 'categories';
  _categoriesGridFields: GridFieldSummary[];
  _selectedcategory: number;
  //Model Type Drop
  assetTypesData: AssetTypeDto[] = [];
  modelClassData: IModelClassDto[] = [];
  _modelTypeAuth: GridFieldAuthorization;
  _selectModelTypeGridActive: boolean;
  _modelTypePageName: string = 'asset-types';
  _modelTypesGridFields: GridFieldSummary[];
  _selectedModelType: number;
  ////// Person ////////
  _personsCode = new FormControl();
  personsData: PersonSummary[] = [];
  _personsAuth: GridFieldAuthorization;
  _personsDD = new FormControl();
  _personsListEnabled: boolean = false;
  _personsGridFields: GridFieldSummary[] = [];
  _personsPageName: string = 'persons';
  _usersPageName: string = 'users';
  _selectedPerson: number;
  // Documents/Pictures
  // #region Videos/Documents/Pictures
  _filesPageName: string = 'files';
  _documentsPageName: string = 'documents'
  _videosPageName: string = 'videos'
  _imageSearchControl = new FormControl();
  _documentSearchControl = new FormControl();
  _videoSearchControl = new FormControl();
  _showImagesGrid: boolean = false;
  _showDocumentGrid: boolean = false;
  _showVideoGrid: boolean = false;
  _imageSearchResult: string;
  _documentSearchResult: string;
  _videoSearchResult: string;
  _filesGridFields: GridFieldSummary[];
  _documentsGridFields: GridFieldSummary[];
  _videosGridFields: GridFieldSummary[];
  _filesGridFieldsSub!: Subscription;
  _selectedImages: any[] = [];
  _selectedImagesKeys: number[] = [];
  _selectedDocuments: any[] = [];
  _selectedDocumentsKeys: number[] = [];
  _selectedVideos: any[] = [];
  _selectedVideosKeys: number[] = [];
  _modelFilesPics: assetModelFile[] = [];
  _modelFilesDoc: assetModelFile[] = [];
  _modelFilesVideo: assetModelFile[] = [];
  _selectedObjectImages: any[] = [];
  _selectedObjectDocuments: any[] = [];
  _selectedObjectVideos: any[] = [];
  _selectedUpsertImagesKeys: number[] = [];
  // #region Enterprise Data
  _addClassActive: boolean = false;
  _selectedAccounts: any[] = [];
  declare _tabEnabled: boolean;
  _isMultiSite: boolean = false;
  _isMultiSiteSelected: boolean = false;
  // #endregion
  constructor(private _accountsService: AccountsService,
    private _fb: FormBuilder,
    private sitesService: MultiSiteService,
    private _assetModelService: AssetModel2Service,
    private _assetTypeService: AssetTypeService,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _sharedService: SharedService,
    private _securityService: SecurityService,
    private _themeManager: ThemeManagerService,
    private _upcOnlineSettingsService: UPCOnlineSettingsService,
    private _customFieldsService: CustomFieldsService,
    private _gridFields: GridFieldsService,
    //private _barcodeGeneratorsService: BarcodeGeneratorsService,
    private _categoriesService: CategoriesService,
    private _layoutManager: LayoutManagerService,
    private _dataService: GDataService,
    private _filesService: FilesService,
    private _modelClassService: ModelClassService,
    private _usersService: UsersService,
    private _layoutComponent: LayoutComponent) {
    super();
  }

  ngOnInit(): void {
    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });

    if (window.navigator.userAgent.indexOf('Mac') != -1) {
      this._isOs = true;
    };

    this._storagePath = EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/';
    this._layoutManager.applyOverly();
    this._currentUser = this._securityService.currentUser;
    this._getdata();
    this._initForm();
    this._getAccountIds();
    this.getAuth();
    this.getSystemFieldsAndCustomFields();
    this._getInactiveFields();
    this.loadLabels();
    this.getFormTabs();
    this.getCategoryAuth();
    this.getModelTypeAuth();
    this.getSitesAuth();

    this._upcOnlineSettingsService.getUPCOnlineSettings().subscribe(data => {
      if (data != undefined && data != null) {
        this.isUpcOnlineSetting = data.enabled;
      }
    });

    //#region person Subscription
    this._usersService.personAdded.subscribe(personId => {
      this._usersService.getPersonById(personId).subscribe(person => {
        this.personsData.push(person);
        this._personsDD.setValue(person);
        this._form.patchValue({ person: person });

        this._form.controls.person.setValue(person);
      });
    })
    //#endregion

    // Tab Position
    let windowSize = window.innerWidth;

    if (windowSize <= 991) {
      this._kendoTabStripPosition = 'top';
    }
    else {
      this._kendoTabStripPosition = 'left';
    }

    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        if (this.kendoInputModelNumber)
          this.kendoInputModelNumber.nativeElement.focus();
      }, 500);
    }

    this._checkMultiSitesLicense();

    if (!this._currentUser.isEnterprise) {
      this._loadCategoriesDD();
      this._loadModelTypesDD();
    }

    this._loadModelClassesDD();

    this._dataService.dataTransferObservable.subscribe(str => {
      if (str.isAttachment == true) {
        if ((str?.response && str.component == 'files')) {
          this._addPicture(str);
          this._isDialiog = false;

        }

        if (str?.response && str.component == 'documents') {
          this._addDocument(str);
          this._isDialiog = false;
        }
      }
      else {
        if (str?.response && str.component == 'asset-types') {
          this._onCloseAddAssetType(str);
          this._isDialiog = false;
        }

        if (str?.response && str.component == 'categories') {
          this._onCloseCategoryType(str);
          this._isDialiog = false;
        }

        if (str?.response && str.component == 'sites') {
          this._onCloseSite(str);
          this._isDialiog = false;
        }
      }
    });
    //this._getFilesGridFields();
    //this._getDocumentsGridFields();
    //this._getModelTypeGridFields();
    this._setGridFieldBehaviour();

    if (this._sharedService?.model?.transactionAssetModelNumber) {
      this._form.patchValue({
        number: this._sharedService?.model?.transactionAssetModelNumber
      });
    }
  }

  ngOnDestroy(): void {
    if (this._filesGridFieldsSub) this._filesGridFieldsSub.unsubscribe();
  }



  // #region Initial Loading

  _checkMultiSitesLicense() {
    this._securityService.getLicense().subscribe((data: any) => {
      if (data.general.numberOfSites > 1) {
        this._isMultiSite = true;
      }

      if (this._isMultiSite == true) {
        var userSites = JSON.parse(localStorage.getItem('loggedInAccountSites'));
        let selectedSite = userSites[0].siteId;

        if (selectedSite == null || selectedSite == this.SitesEnum.AllSites) {
          this._isMultiSiteSelected = true;
          this._loadSitesDD();
        } else {
          this.getPersonsDD();
        }
      }
      else {
        this.getPersonsDD();
      }
    });
  }

  _setGridFieldBehaviour() {
    this.behavior = this._gridLayoutManagerService.subscribeToColumnsChanges2()

    this.behavior.subscribe(value => {
      if (value != undefined && value != null) {
        let pagename = value.map((a: any) => a.page).shift();
        let Gridresualt = value.filter((a: any) => a.selected === true && a.page === pagename);

        switch (pagename) {
          case 'files': {
            this._filesGridFields = Gridresualt;
            break;
          }
          case 'documents': {
            this._documentsGridFields = Gridresualt;
            break;
          }
          case 'videos': {
            this._videosGridFields = Gridresualt;
            break;
          }
          case 'asset-types': {
            this._modelTypesGridFields = Gridresualt;
            break;
          }
          case 'categories': {
            this._categoriesGridFields = Gridresualt;
            break;
          }
          case 'sites': {
            this._sitesGridFields = Gridresualt;
            break;
          }
          default:
            break;
        }
      }
    });
  }

  _getdata(): void {
    this._model = this._sharedService.model && this._sharedService.model.model ? this._sharedService.model.model : null;
    this._pageState = this._sharedService.model && this._sharedService.model.pageState ? this._sharedService.model.pageState : null;
    this._active = true;

    if (this._model?.modelFiles) {
      this._model.modelFiles.forEach((element: any) => {
        if (element.file?.type.includes('image')) {
          this._modelFilesPics.push(element);
        }
        else if (element.file?.type.includes('application')) {
          this._modelFilesDoc.push(element);
        }
        else if (element.file?.type.includes('video')) {
          this._modelFilesVideo.push(element);
        }
      });
    }

    if (this._pageState == PageState.COPY) {
      this.copyModelId = this._model.id; // for loading custom fields data if there is any
      this._model.modelFiles?.forEach((f: assetModelFile) => { f.modelId = 0; f.id = 0; });

      this._model.modelInfo.id = null;
      this._model.modelInfoId = null;
    }

    if (this._pageState == PageState.EDIT || this._pageState == PageState.VIEW) {
      this._selectedAccounts = (this._model?.modelSites ?? []).map((item: any) => ({
        siteId: item.site?.id ?? item.siteId,
        accountId: item.account?.id ?? item.accountId
      }));
      this._selectedAccountIds = this._selectedAccounts.map((a: any) => +a.accountId);
    }

    if (this._currentUser.isEnterprise) {
      this._tabEnabled = this._selectedAccounts.length > 0;
    }
    else {
      this._tabEnabled = true;
    }

    if ((this._pageState === PageState.ADD || this._pageState == PageState.COPY) && this._model && this._model.id > 0) {
      this._model.id = null;
    }
  }

  _getAccounts = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    const v = this._accountsService.getAccounts(params, model);
    return v;
  };

  _getAccountIds() {
    super._getAccountIds(this._model.modelSites);
  }

  private loadLabels(): void {
    this._gridFields.getGridFieldTextLabelByPage(this._page, this._language).subscribe((data: GridFieldTextSummary[]) => {
      this._gridFieldText = data;
      // this._initForm();
    });
  }

  _initForm(): void {
    var _allSitesObj: any = {};
    _allSitesObj.code = 'All Sites';
    _allSitesObj.name = 'All Sites';
    _allSitesObj.id = SitesEnum.AllSites;

    this._form = this._fb.group({
      number: [this._model.number, Validators.required],
      name: [this._model.name, this.getLabel('LBL_ModelName')?.isRequired ? Validators.required : null],
      //name:[this._model.name, Validators.required],
      site: [this._model?.site ?? _allSitesObj, this.getLabel('LBL_SiteCode')?.isRequired ? Validators.required : null],
      infoCost: [this._model.modelInfo?.cost, this.getLabel('LBL_InfoCost')?.isRequired ? Validators.required : null],
      infoAdditionalDescription: [this._model.modelInfo?.additionalDescription, this.getLabel('LBL_InfoAdditionalDescription')?.isRequired ? Validators.required : null],
      infoModelManufacturer: [this._model.modelInfo?.modelManufacturer, this.getLabel('LBL_InfoModelManufacturer')?.isRequired ? Validators.required : null],
      infoCategory: [this._model.modelInfo?.category, this.getLabel('LBL_InfoCategoryId')?.isRequired ? Validators.required : null],
      modelType: [this._model.assetType, this.getLabel('LBL_AssetTypeModelType')?.isRequired ? Validators.required : null],
      modelClass: [this._model.modelClass, this.getLabel('LBL_ModelClass')?.isRequired ? Validators.required : null],
      person: [this._model.person, this.getLabel('LBL_AssetReservationPerson')?.isRequired ? Validators.required : null],
    });
  }
  // #endregion

  // #region Page Spesific
  _loadSitesDD() {
    this._loadSites(this.sitesService, () => {
      this.getPersonsDD();
    });
  }

  _onCloseSite(data: any) {
    let newItem = data.retSite;
    this.sitesData.push(newItem);
    this._sitesDD.setValue(newItem);
    this._form.patchValue({ site: newItem });
  }

  _loadCategoriesDD() {
    let model = {};

    if (this._currentUser.isEnterprise) {
      model = { accountIds: this._selectedAccounts.map((x) => x.accountId) };
    }

    this._categoriesService.getCategoriesListing(model).subscribe((data: any) => {
      this.categoriesData = data;
    });
  }

  _loadModelTypesDD() {
    let model = {};

    if (this._currentUser.isEnterprise) {
      model = { accountIds: this._selectedAccounts.map((x) => x.accountId) };
    }

    this._assetTypeService.getAssetTypeListing(model).subscribe((data: any) => {
      this.assetTypesData = data;
    });
  }

  _loadModelClassesDD() {
    this._modelClassService.getModelClassListing().subscribe((data: any) => {
      this.modelClassData = data;
    });
  }

  _onCloseAddAssetType(data: any) {
    let newItem = data.response;
    this.assetTypesData.push(newItem);
    this._modelTypeDD.setValue(newItem);
    this._form.patchValue({
      modelType: newItem
    });
  }

  _onCloseCategoryType(data: any) {
    let newItem = data.retCategory;
    this.categoriesData.push(newItem);
    this._categoryDD.setValue(newItem);
    this._form.patchValue({
      infoCategory: newItem
    });
  }

  // #region Model Type Select Popup
  _openModelTypeList(): void {
    if (this._modelTypesGridFields == undefined || this._modelTypesGridFields.length == 0) {
      this._getModelTypeGridFields();
    }

    this._selectModelTypeGridActive = true;
  }

  _closeModelTypeList(): void {
    this._selectModelTypeGridActive = false;
  }

  _returnSelectedModelTypeHandler(e: IModelClassDto): void {
    this._assetTypeService.getAssetTypeById(this._selectedModelType).subscribe((data: any) => {
      if (this.assetTypesData.find(f => f.id == data.id) == undefined) {
        this.assetTypesData.push(data);
      }

      this._modelTypeDD.setValue(data);
      this._form.patchValue({
        modelType: data
      });
    })
    /* this._modelTypeDD.setValue(this._selectedModelType);
    this._form.patchValue({
      modelType:this._selectedModelType
    }); */
    this._closeModelTypeList();
  }

  _getModelTypeGridFields() {
    this._gridFields
      .getGridFieldsByPage(this._modelTypePageName)

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects(this._modelTypePageName, data);
      });
    this._gridLayoutManagerService.subscribeToColumnsChanges(this._modelTypePageName, (gridColumns) => {
      this._modelTypesGridFields = gridColumns;
    });
  }

  _getModelTypes = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    if (this._currentUser.isEnterprise) {
      //model.accountIds = this._selectedAccountIds;
      model.accountIds = this._selectedAccounts.map((x) => x.accountId);
    }

    return this._assetTypeService.getAssetTypeGrid(params, model);
  };

  _onModelTypeRowSelectionChanges(e: any[]) {
    this._selectedModelType = e[0];

  }

  _onModelTypeObjectRowSelectionChanges(e: any[]) {
    this._selectedObjectImages = [];
    this._selectedObjectImages = e;
  }
  // #endregion

  // #region Categories Select Popup
  _openCategoryList(): void {
    if (this._categoriesGridFields == undefined || this._categoriesGridFields.length == 0) {
      this._getCategoriesGridFields();
    }

    this._selectCategoriesGridActive = true;
  }

  _closeCategoriesList(): void {
    this._selectCategoriesGridActive = false;
  }

  _returnSelectedCategoriesHandler(e: CategorySummary): void {
    this._categoriesService.getCategory(this._selectedcategory).subscribe((data: any) => {
      if (this.categoriesData.find(f => f.id == data.id) == undefined) {
        this.categoriesData.push(data);
      }

      this._categoryDD.setValue(data);
      this._form.patchValue({
        infoCategory: data
      });
    });

    this._closeCategoriesList();
  }

  _getCategoriesGridFields() {
    this._gridFields.getGridFieldsByPage(this._categoriesPageName).subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects(this._categoriesPageName, data);
    });

    this._gridLayoutManagerService.subscribeToColumnsChanges(this._categoriesPageName, (gridColumns) => {
      this._categoriesGridFields = gridColumns;
    });
  }

  _getCategories = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    if (this._currentUser.isEnterprise) {
      //model.accountIds = this._selectedAccountIds;
      model.accountIds = this._selectedAccounts.map((x) => x.accountId);
    }

    return this._categoriesService.getCategories(params, model);
  };

  _onCategoryRowSelectionChanges(e: any[]) {
    this._selectedcategory = e[0];

  }
  _onCategoryObjectRowSelectionChanges(e: any[]) {

  }
  // #endregion

  // #region Sites Select Popup
  _openSitesList(): void {
    if (this._sitesGridFields == undefined || this._sitesGridFields.length == 0) {
      this._getSitesGridFields();
    }

    this._selectSitesGridActive = true;
  }

  _closeSitesList(): void {
    this._selectSitesGridActive = false;
  }

  _returnSelectedSitesHandler(e: SiteLisitng): void {
    this.sitesService.getSiteById(this._selectedsite).subscribe((data: any) => {
      if (this.sitesData.find(f => f.id == data.id) == undefined) {
        this.sitesData.push(data);
      }

      this._sitesDD.setValue(data);
      this._form.patchValue({ site: data });
    });

    this._closeSitesList();
  }

  _getSitesGridFields() {
    this._gridFields.getGridFieldsByPage(this._sitesPageName).subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects(this._sitesPageName, data);
    });

    this._gridLayoutManagerService.subscribeToColumnsChanges(this._sitesPageName, (gridColumns) => {
      this._sitesGridFields = gridColumns;
    });
  }

  _getSites = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this.sitesService.getSitesGrid(params, model);
  };

  _onSiteRowSelectionChanges(e: any[]) {
    this._selectedsite = e[0];
  }

  _onSiteObjectRowSelectionChanges(e: any[]) {

  }
  // #endregion
  // #endregion

  getPersonsDD(): void {
    this._form.patchValue({ toPerson: null });
    let siteIdd: number | null;

    if (!this._currentUser.isEnterprise) {
      siteIdd = this._form.get('site').value?.id ?? this.siteId;
    }
    this._usersService.getActivePersons(null, siteIdd).subscribe((data: any) => {
      this.personsData = data.body;
    });
  }

  _openPersonsList(): void {
    if (this._personsGridFields == undefined || this._personsGridFields.length == 0) {
      this._getPersonsGridFields();
    }

    this._personsListEnabled = true;
  }

  _getPersonsGridFields() {
    this._gridFields.getGridFieldsByPage(this._personsPageName).subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects(this._personsPageName, data);
    });

    this._gridLayoutManagerService.subscribeToColumnsChanges(this._personsPageName, (gridColumns) => {
      this._personsGridFields = gridColumns;
    });
  }

  _closePersonsList(): void {
    this._personsListEnabled = false;
  }

  _returnSelectedPersonsHandler(e: UserSummary): void {
    this._usersService.getPersonById(this._selectedPerson).subscribe((data: any) => {
      if (this.personsData.find(f => f.id == data.id) == undefined) {
        this.personsData.push(data);
      }

      this._personsDD.setValue(data);
      this._form.patchValue({ person: data });
    });

    this._closePersonsList();
  }

  _onPersonsRowSelectionChanges(e: any[]) {
    this._selectedPerson = e[0];
  }

  _onPersonsObjectRowSelectionChanges(e: any[]) {

  }

  _getPersons = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    let siteIdd: number | null;

    if (!this._currentUser.isEnterprise) {
      siteIdd = this._form.get('site').value?.id ?? this.siteId;
    }

    return this._usersService.getPersonsGridData(params, model, null, siteIdd);
  };

  _onCloseAddPersons(data: any) {
    let newItem = data.response;
    this.personsData.push(newItem);
    this._personsDD.setValue(newItem);
    this._form.patchValue({ person: newItem });
  }

  // #region Fields Tab Containers
  getCustomForm(event: any) {
    this._customForm = event;
  }

  _onTabSelect(e: SelectEvent): void {
    this._mobileMenuToggle();
  }

  _mobileMenuToggle() {
    let mobiletabstrip = this.screenTabs.nativeElement.querySelector('ul');

    if (mobiletabstrip.classList != undefined) {
      mobiletabstrip.classList.toggle('visibletab');
    }
  }

  getFormTabs() {
    try {
      this._gridFields.getformTabsByPage(this._page).subscribe((x: FormTabSummary[]) => {
        this._dataTabs = x;
        this._dataTabsSelected = x;
        this._userNewDataTabs = x;
        //this.sortProduct(p => p.order, "ASC");
      });
    } catch { }
  }

  getSystemFieldsAndCustomFields() {
    this._gridFields.getSystemFieldsByPage(this._page)

      .subscribe((x: any) => {
        this._systemFields = x;
        this._editedSystemFields = x;
        this.loadCustomFields(this._model?.id?.toString());
      })
  }
  private loadCustomFields(entityId?: string) {
    entityId = this.copyModelId?.toString() ?? this._model?.id?.toString();
    //this._pacer.start();
    this._customFieldsService.getCustomFields(this._entity, this._page).subscribe((data) => {
      data.forEach((fieldData: CustomFieldSummary) => {
        if (fieldData.customFieldType.type.toLowerCase() == 'date') {
          if (fieldData.customFieldsData) {
            let _cutomfieldData = fieldData.customFieldsData.find(f => f.entityId == entityId);
            if (_cutomfieldData && _cutomfieldData.value) {
              _cutomfieldData.value = new Date(_cutomfieldData.value).toUTCString();
            }
          }
        }
      });

      data = data.filter(x => x.formTab?.page == this._page);

      if (this._model != null && (this._model.id != null || this.copyModelId != null)) {
        let that = this;
        data.map(function (x) {
          x.entityId = that._model.id ?? that.copyModelId;
        });
      }

      var tabIds = data.map((item) => item.formTabId).filter((value, index, self) => self.indexOf(value) === index);

      const grouped = this.groupBy(data, (item: { formTabId: any }) => item.formTabId);

      let that = this;
      tabIds.forEach(function (formTabId) {
        that._customFields[formTabId] = grouped.get(formTabId);
      });

      if (this.copyModelId) {
        let CustomFieldsDataForCopy: any = {};
        grouped.forEach(element => {
          element.forEach((value: any) => {
            let _cutomfieldData = value.customFieldsData.find((f: any) => f.entityId == entityId);
            CustomFieldsDataForCopy[value.name] = _cutomfieldData.value ?? null;

            if (value.customFieldType.type.toLowerCase() == 'date' && CustomFieldsDataForCopy[value.name]) {
              CustomFieldsDataForCopy[value.name] = new Date(CustomFieldsDataForCopy[value.name]);
            }

            if (value.customFieldType.type.toLowerCase() == 'numeric' && CustomFieldsDataForCopy[value.name])
              CustomFieldsDataForCopy[value.name] = parseFloat(CustomFieldsDataForCopy[value.name]);
          });

          this._customFieldsValueChanges(CustomFieldsDataForCopy, null);

        });
      }

      this.setMandatoryFields();
    });
    //this._pacer.start()
    this._customFieldsService.getFormTabsByPage(this._page).subscribe((data: any) => {
      //get custom tabs first
      this._customTabs = data.filter(
        (x: { isCustom: boolean }) => x.isCustom == true
      );
    });
  }

  groupBy(list: any[], keyGetter: any) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);

      if (!collection) {
        map.set(key, [item]);
      }
      else {
        collection.push(item);
      }
    });

    return map;
  }
  setMandatoryFields() {
    this._requiredFieldNames = [];
    this._requiredFields = [];
    this.requiredSystemTabs = [];

    setTimeout(() => {
      for (let item of this._systemFields) {
        if (item.gridFieldText.isRequired) {
          this._requiredFields.push(item);
        }
      }

      for (let item2 of this._customFields) {
        if (item2) {
          for (let item3 of item2) {
            if (item3.isRequired) {
              this._requiredFields.push(item3);
            }
          }
        }
      }

      this._requiredFields.forEach((element: { isCustomField: any; formTab: any; formTabId: any; }) => {
        if (!element.isCustomField && element.isCustomField == null) {
          var tabName = element.formTab;
          this._requiredFieldNames.push(tabName);
        }
        else {
          if (element.formTabId) {
            let SystemFieldTab = this._dataTabs.find(x => x.id == element.formTabId);

            if (SystemFieldTab)
              this.requiredSystemTabs.push(SystemFieldTab);
          }
        }
      });

      if (this.screenTabs) {
        let tabElementList = this.screenTabs.nativeElement.querySelector('ul');
        Array.from(tabElementList.children).forEach((child: any) => {
          child.classList.remove('mendatoryTab');
        });

        Array.from(tabElementList.children).forEach((child: any) => {

          if (this._requiredFieldNames.find((x: { name: any; page: string; formtab: { page: string; }; }) => x.name === child.firstChild.innerText && (x.page ? x.page == this._page : x.formtab.page == this._page))) {
            child.classList.add("mendatoryTab")
          }

          if (this.requiredSystemTabs.find((x: any) => x.name === child.firstChild.innerText)) {
            child.classList.add('mendatoryTab');
          }
        });
      }

      this._requiredFields.forEach((element: { isCustomField: any; formTab: { name: any; }; customFieldsData: any[]; name: any; }) => {
        if (!element.isCustomField && element.isCustomField == null) {
          var tabName = element.formTab;
          this._requiredFieldNames.push(tabName);
        }

        if (element.customFieldsData != undefined) {
          let thisvalue = element.customFieldsData.filter((x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId)).length > 0
            ? element.customFieldsData.filter((x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId))[0].value
            : '';

          this._customValidation.push({
            name: element.name,
            value: thisvalue,
            tabName: element.formTab?.name,
          });
        }
      });


    }, 500);

  }

  _deactivateTab(tabId: number, page: string) {
    let model: any = {
      customFieldEntityId: page == this._page ? 1 : 2,
      page: this._page,
      accountIds: this._selectedAccountIds,
    };
    this._customFieldsService.deleteCustomTab(tabId, model).subscribe((response: any) => {
      if (response != null && response['message'] != null) {
        var deletedTab = this._dataTabs.find(f => f.id == tabId && f.isCustom == true);
        this._dataTabs.splice(this._dataTabs.indexOf(deletedTab), 1);
        //go to zero based tab
        this.screenTabStrip.selectTab(0);
        this._customFieldsService
          .getFormTabsByPage(this._page)

          .subscribe((data: any) => {
            //get custom tabs first
            this._customTabs = data.filter((x: { isCustom: boolean; }) => x.isCustom == true);
          });
        this._layoutComponent.openPopup({
          title: 'Alert',
          message: response['message'],
          withoutConfirm: true
        });

        if (response['close'] != null) {
          if (response['close'] == true) {

          } else {
            return;
          }
        }
      }
    });
  }

  _reorderingtabs() {
    this._orderingTabsForm = true;
  }

  _closeOrderingTabsForm() {
    this._orderingTabsForm = false;
    this._dataTabsSelected = this._userNewDataTabs;
  }

  _comboValueChange(e: any, i: number) {
    if (this._dataTabsSelected.find((x) => x.order == i + 1)) {
      this._userNewDataTabs.find((x) => x === this._dataTabsSelected.find((x) => x.order == i + 1)).order = this._dataTabsSelected.find((x) => x.name === e.name).order;
    }

    this._userNewDataTabs.find((obj) => obj.name == e.name).order = i + 1;
    //this._dataTabsSelected = this._dataTabsSelected.filter((obj) => obj !== e);
  }

  _onSaveTabOrdering() {
    this._gridFields.updateFormTabsReorder(this._userNewDataTabs).subscribe((x: any) => {
      this._dataTabs = x;
      this._closeOrderingTabsForm();
    });
  }
  // #endregion

  // #region Window Events
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this._innerWidth = window.innerWidth;
    if (this._innerWidth > 450) {
      this._hiddenWindow = 'hidden';
      this._maximized = 'maximized';
    }
    else {
      this._hiddenWindow = '';
      this._maximized = 'default';
    }

    let windowSize = window.innerWidth;

    if (windowSize <= 991) {
      this._kendoTabStripPosition = 'top';
    }
    else {
      this._kendoTabStripPosition = 'left';
    }
  }

  // #endregion

  // #region Page Controls Actions
  _upcSubmitted(): void {
    this._modelNumber.setValue(this._form.get('number').value);
    if (this._modelNumber.value != null) {
      if (this._pageState == PageState.ADD) {
        setTimeout(() => {
          this.kendoInputModelName.nativeElement.focus();
          let modelNameInput = this.kendoInputModelName;
          modelNameInput.nativeElement.classList.add('focusedInput');
        });
      }
    }
  }

  _searchUPC(): void {
    this._form.patchValue({
      name: '',
      infoModelManufacturer: '',
      infoCost: '',
      infoAdditionalDescription: '',
    });

    if (this._form.controls.number.value != undefined && this._form.controls.number.value.trim() != '') {
      this._assetModelService.upcSearch(this._form.controls.number.value).subscribe((data: IUPCBarcodes[]) => {
        if (data) {
          this._selectedUPC = undefined;
          this._upcResult = [...data];
          this.isUPCResultEnabled = true;
        }
        else {
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: 'The entered model number did not return any result(s) or it does not exist',
            withoutConfirm: true
          });
        }
      })
    }
    else {
      this._layoutComponent.openPopup({
        title: 'Alert',
        message: 'Please enter the model number to initiate the search',
        withoutConfirm: true
      });
    }
  }

  _closeUpcWindow() {
    this.isUPCResultEnabled = false;
  }

  _selectUPCItem(e: SelectionEvent) {
    this._selectedUPC = e.selectedRows[0].dataItem;
  }

  _returnSelectedUPCItem() {
    this._form.patchValue({
      name: this._selectedUPC.title,
      infoModelManufacturer: this._selectedUPC.manufacturer,
      infoCost: this._selectedUPC.price,
      infoAdditionalDescription: this._selectedUPC.description,
    });

    this._closeUpcWindow();
  }

  getLabel(objectCode: string): GridFieldTextSummary {
    if (this._gridFieldText) {
      if (this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)) {
        var result = this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode);
      }
      else {
        result = null;
      }

      return result ? result : null;
    }
  }
  // #endregion

  // #region Popup Action Buttons
  _onSave(e: string): any {
    var sitesSelected: boolean = true;
    if (this._currentUser.isEnterprise) {
      if (this._currentUser.isEnterprise && this._selectedAccounts.length === 0) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please select account(s) to continue.',
        });

        return false;
      }
      else {
        var tmpAccountSites = this._selectedAccounts.filter((x: any) => x.siteId != -1);

        if (tmpAccountSites.length != this._selectedAccounts.length) {
          this._layoutComponent.openPopup({
            title: 'Validation',
            message: 'Please select the site(s) of the selected account(s) to continue.',
          });

          sitesSelected = false;

          return false;
        }
      }
    }

    if (this._isMultiSiteSelected == true && !this._form.get('site').value) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please select the site to continue.',
      });

      return false;
    }

    this._invalidForm = false;

    if (isNaN(this._form.get('infoCost').value)) {
      this._invalidForm = true;
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
      this._layoutComponent.openPopup({
        title: 'Alert',
        message: 'Please enter numbers only in Cost',
        withoutConfirm: true
      });
    }

    if (!this._invalidForm) {
      if (this._form.invalid && this._customValidation.find((x: any) => !x.value)) {
        this._invalidForm = true;
        this._invalidSubmit = true;
        this._additionalErrors.push("Additional Error");
        this._additionalErrors = [];
      }
      else if (this._form.invalid) {
        this._invalidForm = true;
      }
      else if (this._customValidation.find((x: any) => !x.value)) {
        this._additionalErrors.push("Additional Error");
        this._additionalErrors = [];
        this._invalidSubmit = true;
        this._invalidForm = true;
      }
      else {
        // work with custom fields
        if (this._customFieldsValue) {
          this._customFieldsValue.forEach((elementy: any) => {
            this._customFieldsDictionary[elementy.Key] = elementy.Value;
          });
        }
        this._invalidForm = false;
        this._invalidSubmit = false;
        //Generate Request Model
        const model: IAssetModelDto = this.generateRequestModel();
        if ((this._pageState == PageState.ADD || this._pageState == PageState.COPY) && this._model.id == null) {
          this._assetModelService.createAssetModel(model).subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              if (!this._currentUser.isEnterprise) {
                this.note.createNote(response.responseId);
              }
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });

              if (response['close'] != null) {
                if (response['close'] == true) {
                  let modelEmit = { ...model };
                  modelEmit.id = response.responseId;
                  this._assetModelService.assetModelAdded.emit(modelEmit);

                  if (e === 'saveAndClose') {
                    model.id = response.responseId;
                    this._closeForm(model);
                  }
                  else if (e === 'saveAndCopy') {
                    this._form.controls.number.setValue(null);
                    this.copyModelId = this._model.id;
                    this.loadCustomFields(this.copyModelId.toString());
                    this._model.id = null;
                    this._model.modelInfo.id = null;
                    this._model.modelInfoId = null;
                    this._pageState = PageState.COPY;
                  }
                  else if (e === 'save') {
                    this._pageState = PageState.EDIT;
                    this._model = response.extraData;
                    this._model.id = response.responseId;
                  }
                  else if (e === 'saveAndNew') {
                    this._active = false;
                    this.openUpsert(this._page, {}, PageState.ADD);
                  }
                }
                else {
                  return;
                }
              }
            }
          });
        }
        else if (this._pageState == PageState.EDIT) {
          if (this._model.id == null) {
            this._model.id = model.id;
          }
          this._assetModelService.updateAssetType(this._model.id, model).subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });

              if (response['close'] != null) {
                if (response['close'] == true) {
                  let modelEmit = { ...model };
                  modelEmit.id = this._model.id;
                  this._assetModelService.assetModelUpdated.emit(modelEmit);

                  if (e === 'saveAndClose') {
                    model.id = this._model.id;
                    this._closeForm(model);
                  }
                  else if (e === 'saveAndCopy') {
                    this._form.controls.number.setValue(null);
                    this.copyModelId = this._model.id;
                    this.loadCustomFields(this.copyModelId.toString());
                    this._model.id = null;
                    this._model.modelInfo.id = null;
                    this._model.modelInfoId = null;
                    this._pageState = PageState.COPY;
                  }
                  else if (e === 'save') {
                    this._pageState = PageState.EDIT;
                  }
                  else if (e === 'saveAndNew') {
                    this._active = false;
                    this.openUpsert(this._page, {}, PageState.ADD);
                  }
                }
                else {
                  return;
                }
              }
            }
          });
        }
      }
    }
  }

  private generateRequestModel(): IAssetModelDto {
    let _modelFiles: assetModelFile[] = [];
    _modelFiles.push(...this._modelFilesPics);
    _modelFiles.push(...this._modelFilesDoc);
    _modelFiles.push(...this._modelFilesVideo);

    const retModel: IAssetModelDto = <IAssetModelDto>({
      modelInfoId: this._model?.modelInfo?.id ?? 0,
      name: this._form.get('name').value,
      number: this._form.get('number').value,
      assetType: this._form.get('modelType').value,
      assetTypeId: this._form.get('modelType').value?.id,
      modelClass: this._form.get('modelClass').value,
      modelClassId: this._form.get('modelClass').value?.id,
      person: this._form.get('person').value,
      personId: this._form.get('person').value?.id,
      customFieldsValue: this._customFieldsDictionary,
      siteId: this._isMultiSiteSelected ? this._form.get('site').value?.id : this.siteId,
      //site: this._form.get('site').value,
      accountIds: this._selectedAccountIds.map((c) => c),
      modelSites: this._currentUser.isEnterprise ? this._selectedAccounts.map((c: any) => {
        return {
          siteId: this._form.get('site').value?.id ?? c.siteId,
          accountId: c.accountId
        }
      }) : null,
      modelInfo: <IModelInfo>({
        id: this._model?.modelInfo?.id ?? 0,
        additionalDescription: this._form.get('infoAdditionalDescription').value,
        categoryId: this._form.get('infoCategory').value?.id,
        category: this._form.get('infoCategory').value,
        cost: this._form.get('infoCost').value,
        modelManufacturer: this._form.get('infoModelManufacturer').value
      }),
      modelFiles: <assetModelFile[]>(_modelFiles)
    });

    return retModel;
  }

  _edit(): void {
    this._pageState = PageState.EDIT;
  }

  _openForm(componentName: string, objectname: any = null) {
    this._isDialiog = true;
    this._dialogComponentName = componentName;
    this._dialogModel = { model: {}, pageState: PageState.ADD, reload: 'model', fileSource: fileSources.assetModel };
    this._isMandatory = false;
    this.selectedobjectname = objectname;
  }

  _closeDialog(fileData: any) {
    this._isDialiog = false;
  }
  // #endregion

  // #region Custom Fields / Forms Actions
  formStatus(isInvalid: boolean) {
    this._custominvalidForm = isInvalid;
  }

  _onEditFields() {
    if (!this._currentUser.isEnterprise) {
      this._pageState = PageState.EDIT_FIELDS;
    }
    else {
      if (!this._selectedAccounts.length) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the desired account in the Accounts Tab',
          withoutConfirm: true
        });
      }
      else {
        this._pageState = PageState.EDIT_FIELDS;
        // this._editFormActive = true;
        // this._isCustomfieldsFormValue = true;
      }
    }
  }

  _addNewTab() {
    this._editFormActive = true;
    this._isAddTabFormValue = true;
    this._isRenameLabel = false;
    this._selectedLabelId = null;
  }

  _addNewField(tabId: number) {
    this._selectedTabId = null;
    this._selectedTabId = tabId;
    this._editFormActive = true;
    this._isCustomfieldsFormValue = true;
    this._isRenameLabel = false;
  }

  _openRenameForm(objectCode: string, isMandatory: boolean = false) {
    this._selectedLabelObjectCode = objectCode; //todo send system field label id
    //return; //open form once label id is set
    this._editFormActive = true;
    this._isRenameFormValue = true;
    this._isRenameCustomFormValue = false;
    this._isRenameLabel = true;
    this._isMandatory = isMandatory;
  }

  _openCustomRenameForm(customFieldId: number, tabId: number) {
    this._selectedLabelId = customFieldId;
    this._selectedTabId = tabId;
    this._editFormActive = !isNaN(customFieldId);
    this._isRenameFormValue = !isNaN(customFieldId);
    this._isRenameCustomFormValue = !isNaN(customFieldId);
    this._isRenameLabel = false;
    this._isMandatory = false;
  }

  _onEditForms() {
    this._isEditForms = true;
  }

  _onCloseEditForms(event: boolean) {
    this._isEditForms = event;
  }

  _returnAdNew() {
    this._pageState = PageState.ADD;
  }

  _viewInactiveFields() {
    this._getInactiveFields();
    /* this._customFieldsService
      .getDeactivatedCustomFields(this._entity, this._page)
      
      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page);
      }); */
    this._deactivatedFieldsForm = true;
  }

  _reactivateField(item: any) {
    this.reactivateItem = item;
    this.reactivate = true;
    this._sharedService.okCloseClicked.subscribe((data: boolean) => {
      if (data && this.reactivate) {
        this.reactivate = false;
        this._customFieldsService.reactivateCustomField(this.reactivateItem.id, item).subscribe((response: any) => {
          this.getSystemFieldsAndCustomFields();
          this._deactivatedFieldsForm = false;
          //get tabid,if not in list call get systemtabs
          var deletedTab = this._dataTabs.find(f => f.id == item.formTabId && f.isCustom == true);

          if (deletedTab == undefined) {
            this.getFormTabs();
          }

          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            /* if (response['close'] != null) {
              if (response['close'] == true) {
                //this.loadCustomFields(this._model?.id?.toString());
              } else {
                return;
              }
            } */
          }

          this._deactivatedFieldsForm = false;
        });
        this._deactivatedFieldsForm = false;
      }
      else {
        this.reactivate = false;
      }
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name
    });
    //this.loadCustomFields(this._model?.id?.toString());
    /* this.getSystemFieldsAndCustomFields();
    this._customFieldsService
    .getDeactivatedCustomFields(this._entity,this._page)
    
    .subscribe((data: Array<any>) => {
      this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page)
    }); */
  }

  _closeInactiveFields() {
    this._deactivatedFieldsForm = false;
  }

  dataMove(newLocData: any, oldLocData: any) {
    const sysF: any[] = this._systemFields;
    const sysFClone: any[] = [];

    sysF.forEach((element: any) => {
      sysFClone.push(Object.assign({}, element));
    });

    this._systemFields.find((x: { id: any; }) => x.id === oldLocData.id).formOrder = sysFClone.find((x) => x.id === newLocData.id).formOrder;
    this._systemFields.find((x: { id: any; }) => x.id === newLocData.id).formOrder = sysFClone.find((x) => x.id === oldLocData.id).formOrder;

    this._editedSystemFields = this._systemFields;
  }

  dragEnd() {
    this._gridFields.updatedSystemFieldReorder(this._editedSystemFields).subscribe((x: any) => {
      this._systemFields = x;
      this._editedSystemFields = x;
    });
  }

  _customFieldsValueChanges(customFieldsValue: any, tabId: number) {
    if (this._customFieldsValue == undefined) { this._customFieldsValue = []; }

    Object.keys(customFieldsValue).forEach((key) => {
      let customObject = {
        Key: key,
        Value: customFieldsValue[key],
      };

      let item = null;
      this._customFieldsValue.forEach((elementz: any) => {
        if (elementz.Key == key) {
          item = elementz;
        }
      });

      if (item != null) {
        let index = this._customFieldsValue.indexOf(item);

        if (index != -1) {
          this._customFieldsValue.splice(index, 1);
        }
      }

      var requiredCustomerField = this._customValidation.find((x: any) => x.name == key);

      if (requiredCustomerField) {
        let item2 = null;
        this._customValidation.forEach((element: any) => {
          if (element.name == key) {
            item2 = element;
          }
        });

        if (item2 != null) {
          let index2 = this._customValidation.indexOf(item2);

          if (index2 != -1) {
            //this._customValidation.splice(index2, 1);
            this._customValidation[index2].value = customObject.Value;
          }
          //this._customValidation.push({'name': customObject.Key, 'value': customObject.Value})
        }
      }

      this._additionalErrors = [];

      if (this._customValidation.find((x: any) => !x.value)) {
        this._additionalErrors.push("Additional Error");
        this._additionalErrors = [];
      }
      this._customFieldsValue.push(customObject);
    });
  }

  _removeCustomField(customFieldId: number) {
    for (var i = 1; i <= this._customFields.length; i++) {
      if (this._customFields[i] != null) {
        if (this._customFields[i].findIndex((x) => x.id == customFieldId) != -1) {
          this._customFields[i] = this._customFields[i].filter((x) => x.id != customFieldId);

          return;
        }
      }
    }
  }

  ClosePopup(event: boolean) {
    if (event == true) {
      this._closeCustomFields();
    }
  }

  _closeCustomFields() {
    this._editFormActive = false;
    this._isCustomfieldsFormValue = false;
    this._isAddTabFormValue = false;
    this._isRenameFormValue = false;
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
    this.loadLabels();
    this.getFormTabs();
    this.getAuth();
  }

  _getInactiveFields() {
    this._customFieldsService.getDeactivatedCustomFields(this._entity, this._page).subscribe((data: Array<any>) => {
      this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page)
    });
  }
  // #endregion

  // #region Popup window Events
  openUpsert(componentName: string, model: any, pageState: PageState) {
    this._isDialiog = true;
    this._active = true;
    this._dialogComponentName = componentName;
    this._dialogModel = { model, pageState }
  }

  _onCancel() {
    this._closeForm();
  }

  _closeForm(model?: any) {
    var closeComponent = {
      component: 'asset-models-2',
      isClosed: true,
      response: model
    }
    this._isDialiog = false;
    this._active = false;
    this._gridLayoutManagerService.setGridDataSubjects('asset-models-2');
    //this.ngOnDestroy();
    this._layoutManager.removeOverlay();
    this._sharedService.closeDialog.emit(closeComponent);
    this._sharedService.model = {};
    //Quraim
    this._dataService.push(closeComponent);
    this._sharedService.model = {};
  }

  _onStateChanges(e: any) {
    var element: any = this.kendoMainWindow;
    if (e === 'minimized') {
      element.el.nativeElement.classList.remove("fullWidthFormForm");
    }
    else if (e === 'maximized') {
      element.el.nativeElement.classList.remove("fullWidthFormForm");
    }
    else if (e === 'default') {
      element.el.nativeElement.classList.add("fullWidthFormForm");
    }
  }

  // #endregion

  // #region Security Levels
  canAccess(scope: string, operation: string): boolean {
    return this._securityService.hasPermission(null, `${scope}-${operation}`);
  }

  getAuth() {
    // this._gridFields.getFileAuthorization(this._auth, this._currentUser.appRole.id)
    this._gridFields.getFieldsAuthorization(this._permissionScope, this._currentUser.appRole.id).subscribe((x: GridFieldAuthorization[]) => {
      this._gridFieldAuth = x;
    });
  }

  getAuthByLabel(objectCode: any) {
    if (this._gridFieldAuth) {
      if (this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
        var result = this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)
      else
        result = null

      return result ? result : new GridFieldAuthorization();
    }
  }

  getModelTypeAuth() {
    this._gridFields.getFileAuthorization('mnuAssetModels', this._currentUser.appRole.id).subscribe((x: GridFieldAuthorization) => {
      this._modelTypeAuth = x;
    });
  }

  getCategoryAuth() {
    this._gridFields.getFileAuthorization('mnuModelCategory', this._currentUser.appRole.id).subscribe((x: GridFieldAuthorization) => {
      this._categoryAuth = x;
    });
  }

  getSitesAuth() {
    this._gridFields.getFileAuthorization('mnuSites', this._currentUser.appRole.id).subscribe((x: GridFieldAuthorization) => {
      this._siteAuth = x;
    });
  }
  // #endregion

  // #region File Library
  //Images / Picutres
  _getFilesGridFields() {
    if (this._filesGridFieldsSub) this._filesGridFieldsSub.unsubscribe();
    this._gridFields.getGridFieldsByPage(this._filesPageName).subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects(this._filesPageName, data);
    });

    this._gridLayoutManagerService.subscribeToColumnsChanges(this._filesPageName, (gridColumns) => {
      this._filesGridFields = gridColumns;
    });
  }

  _selectImagesHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccountIds.length) {
        this._showImagesGrid = true;
      }
      else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    }
    else if (!this._currentUser.isEnterprise) {
      if (this._filesGridFields == undefined || this._filesGridFields.length == 0) {
        this._getFilesGridFields();
      }

      this._showImagesGrid = true;
    }
  }

  _closeImagesWindow(): void {
    this._showImagesGrid = false;
    this._isDialiog = false;
  }

  _returnSelectedImagesHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccountIds.length) {
        this._showImagesGrid = false;
        this._selectedImagesKeys = this._selectedImages;
        this._addPicture();
      }
      else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    }
    else if (!this._currentUser.isEnterprise) {
      this._showImagesGrid = false;
      this._selectedImagesKeys = this._selectedImages;
      this._addPicture();
    }
  }

  _addPicture(fileData: any = null) {
    if (fileData == null) {
      this._modelFilesPics =
        this._modelFilesPics === null ? [] : this._modelFilesPics;
      if (this._selectedObjectImages.length > 0) {
        this._selectedObjectImages.forEach((element: any) => {
          let exists = this._modelFilesPics.find(f => f.fileid == element.id);
          if (exists == undefined) {
            delete element.fileAccounts;
            let addedFileItem: assetModelFile = <assetModelFile>({
              fileid: element.id,
              filename: element.name,
              file: element,
              modelId: this._model.id ? this._model.id : 0,
              status: EntityStatusOptions.Active,
            });
            this._modelFilesPics.push(addedFileItem);
          }
        });
      }
    }
    else {
      let addedFileItem: assetModelFile = <assetModelFile>({
        fileid: fileData.response.id,
        filename: fileData.response.name,
        file: fileData.picObject.file,
        modelId: this._model.id ? this._model.id : 0,
        status: EntityStatusOptions.Active,
      });

      this._modelFilesPics.push(addedFileItem);
    }
  }

  _onImageRowSelectionChanges(e: any[]) {
    this._selectedImages = [];
    e.forEach((item) => {
      this._selectedImages.push(+item);
    });
  }
  _onImageObjectRowSelectionChanges(e: any[]) {
    this._selectedObjectImages = [];
    this._selectedObjectImages = e;
  }

  _getAccountImages = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._filesService.getAccountsPictures(
      this._selectedAccountIds,
      params,
      model
    );
  };

  _setPrimaryPic(data: any) {
    this._modelFilesPics.forEach((element: assetModelFile) => {
      if (element !== data) {
        element.modelFileisPrimary = false;
      }
      else {
        element.modelFileisPrimary = true;
      }
    });
  }

  _removePicHandler(event: any) {
    const index = this._modelFilesPics.indexOf(event, 0);
    if (index > -1) {
      this._modelFilesPics.splice(index, 1);
      this._selectedImagesKeys.splice(this._selectedImagesKeys.indexOf(event), 1);
    }
  }

  _removeFileFromLibrary(event: assetModelFile) {
    //Delete Logic Goes Here
    this._removePicHandler(event);

  }

  _onSelectedImagesChanged(e: any[]) {
  }

  _onSelectedImagesRowChanged(e: any[]) {
  }

  //Documents
  _getDocumentsGridFields() {
    if (this._filesGridFieldsSub) this._filesGridFieldsSub.unsubscribe();
    this._gridFields
      .getGridFieldsByPage(this._documentsPageName)

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects(this._documentsPageName, data);
      });
    this._gridLayoutManagerService.subscribeToColumnsChanges(this._documentsPageName, (gridColumns) => {
      this._documentsGridFields = gridColumns;
    });
  }
  _selectDocumentsHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccountIds.length) {
        this._showDocumentGrid = true;
      } else {
        this._layoutComponent.openPopup({
          title: 'validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      if (this._documentsGridFields == undefined || this._documentsGridFields.length == 0) {
        this._getDocumentsGridFields();
      }
      this._showDocumentGrid = true;
    }
  }
  _closeDocumentsWindow(): void {
    this._showDocumentGrid = false;
  }
  _returnSelectedDocumentsHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccountIds.length) {
        this._showDocumentGrid = false;
        this._selectedDocumentsKeys = this._selectedDocuments;
        this._addDocument();
      } else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      this._showDocumentGrid = false;
      this._selectedDocumentsKeys = this._selectedDocuments;
      this._addDocument();
    }
  }
  _addDocument(fileData: any = null) {
    if (fileData == null) {
      this._modelFilesDoc =
        this._modelFilesDoc === null ? [] : this._modelFilesDoc;

      if (this._selectedObjectDocuments.length > 0) {
        this._selectedObjectDocuments.forEach((element: any) => {
          let exists = this._modelFilesDoc.find(f => f.fileid == element.id && f.status == EntityStatusOptions.Active);
          if (exists == undefined) {
            let addedFileItem: assetModelFile = <assetModelFile>({
              fileid: element.id,
              filename: element.name,
              file: element,
              modelId: this._model.id ? this._model.id : 0,
              status: EntityStatusOptions.Active,
            });
            this._modelFilesDoc.push(addedFileItem);
          }
        });
      }
    }
    else {
      let addedFileItem: assetModelFile = <assetModelFile>({
        fileid: fileData.response.id,
        filename: fileData.response.name,
        file: fileData.picObject.file,
        modelId: this._model.id ? this._model.id : 0,
        status: EntityStatusOptions.Active,
      });
      this._modelFilesDoc.push(addedFileItem);
    }
  }
  _removeDocHandler(event: any) {
    const index = this._modelFilesDoc.indexOf(event, 0);
    if (index > -1) {
      this._modelFilesDoc.splice(index, 1);
      this._selectedDocumentsKeys.splice(this._selectedImagesKeys.indexOf(event), 1);
    }
  }
  _onDocumentsRowSelectionChanges(e: any[]) {
    this._selectedDocuments = [];
    e.forEach((item) => {
      this._selectedDocuments.push(+item);
    });
  }
  _onDocumentObjectRowSelectionChange(e: any[]) {
    this._selectedObjectDocuments = [];
    this._selectedObjectDocuments = e;
  }
  _getAccountDocuments = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._filesService.getDocuments(params, model);
  };
  _doDownloadFile(event: any) {
    let filePath = this._storagePath + event.file.stream;
    var a = document.createElement('a');
    a.href = filePath;
    document.body.appendChild(a);
    a.click();
    a.target = '_blank';
    document.body.removeChild(a);

  }
  //Videos
  _getVideosGridFields() {
    if (this._filesGridFieldsSub) this._filesGridFieldsSub.unsubscribe();
    this._gridFields
      .getGridFieldsByPage(this._videosPageName)

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects(this._videosPageName, data);
      });
    this._gridLayoutManagerService.subscribeToColumnsChanges(this._videosPageName, (gridColumns) => {
      this._videosGridFields = gridColumns;
    });
  }
  _selectVideosHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccountIds.length) {
        this._showVideoGrid = true;
      } else {
        this._layoutComponent.openPopup({
          title: 'validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      if (this._videosGridFields == undefined || this._videosGridFields.length == 0) {
        this._getVideosGridFields();
      }
      this._showVideoGrid = true;
    }
  }
  _closeVideosWindow(): void {
    this._showVideoGrid = false;
  }
  _returnSelectedVideosHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccountIds.length) {
        this._showVideoGrid = false;
        this._selectedVideosKeys = this._selectedVideos;
        this._addVideo();
      } else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      this._showVideoGrid = false;
      this._selectedVideosKeys = this._selectedVideos;
      this._addVideo();
    }
  }
  _addVideo(fileData: any = null) {
    if (fileData == null) {
      this._modelFilesVideo =
        this._modelFilesVideo === null ? [] : this._modelFilesVideo;

      if (this._selectedObjectVideos.length > 0) {
        this._selectedObjectVideos.forEach((element: any) => {
          let exists = this._modelFilesVideo.find(f => f.fileid == element.id && f.status == EntityStatusOptions.Active);
          if (exists == undefined) {
            let addedFileItem: assetModelFile = <assetModelFile>({
              fileid: element.id,
              filename: element.name,
              file: element,
              modelId: this._model.id ? this._model.id : 0,
              status: EntityStatusOptions.Active,
            });
            this._modelFilesVideo.push(addedFileItem);
          }
        });
      }
    }
    else {
      let addedFileItem: assetModelFile = <assetModelFile>({
        fileid: fileData.response.id,
        filename: fileData.response.name,
        file: fileData.picObject.file,
        modelId: this._model.id ? this._model.id : 0,
        status: EntityStatusOptions.Active,
      });
      this._modelFilesVideo.push(addedFileItem);
    }
  }
  _removeVideoHandler(event: any) {
    const index = this._modelFilesVideo.indexOf(event, 0);
    if (index > -1) {
      this._modelFilesVideo.splice(index, 1);
      this._selectedVideosKeys.splice(this._selectedVideosKeys.indexOf(event), 1);
    }
  }
  _onVideosRowSelectionChanges(e: any[]) {
    this._selectedVideos = [];
    e.forEach((item) => {
      this._selectedVideos.push(+item);
    });
  }
  _onVideoObjectRowSelectionChange(e: any[]) {
    this._selectedObjectVideos = [];
    this._selectedObjectVideos = e;
  }
  _getAccountVideos = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._filesService.getVideos(params, model);
  };
  _doDownloadVideo(event: any) {
    let filePath = this._storagePath + event.file.stream;
    var a = document.createElement('a');
    a.href = filePath;
    document.body.appendChild(a);
    a.click();
    a.target = '_blank';
    document.body.removeChild(a);

  }
  // #endregion
  _onAccountRowSelectionChanges(e: any[]) {
    super._onAccountRowSelectionChanges(e, () => {
      setTimeout(() => {
        this._loadCategoriesDD();
        this._loadModelTypesDD();
      }, 200);
    });
  }

}

